import React from 'react';
import { baseMain, primaryMain } from 'crehana-ui/styles/colors';

import Text from 'crehana-ui/Text';
import ArrowRect from 'crehana-icons/ArrowRect';

import useCollapse from 'Jsx/Shared/Hooks/useCollapse';

import { CategoryBlock, Header, Link, Panel } from './MobileFooter.styles';

type Props = {
  title: string;
  items: Array<{
    link: string;
    color: string;
    label: string;
    icon: React.ReactNode;
    bold: boolean;
  }>;
  prefix: string;
  color: string;
};

const Collapsible: React.FC<Props> = ({
  title,
  items,
  prefix,
  color = baseMain,
}) => {
  const { getCollapseProps, getToggleProps } = useCollapse();

  return (
    <CategoryBlock>
      <Header {...getToggleProps()} className="outline-none">
        <Text type="subtitle3" color="gray-dark">
          {title.toUpperCase()}
        </Text>
        <ArrowRect size={8} color={primaryMain} />
      </Header>
      <div {...getCollapseProps()}>
        <Panel>
          <div>
            {items.map((el, index) => {
              if (el.link) {
                return (
                  <Link href={el.link} key={index}>
                    {el.icon}
                    <Text
                      type="body3"
                      style={{ color: el.color || color }}
                      className={el.bold ? 'font-bold' : ''}
                    >
                      {prefix} {el.label}
                    </Text>
                  </Link>
                );
              }
              return (
                <Link as="button" key={index}>
                  {el.icon}
                  <Text
                    type="body3"
                    style={{ color: el.color || color }}
                    className={el.bold ? 'font-bold' : ''}
                  >
                    {prefix} {el.label}
                  </Text>
                </Link>
              );
            })}
          </div>
        </Panel>
      </div>
    </CategoryBlock>
  );
};

export default Collapsible;
